module.exports = __webpack_public_path__ + "static/media/chart-placeholder.d6f9e86e.png";